import React, { FC, useEffect, useMemo, useState } from "react";
import { ChatAgents } from "../../store/ChatState";
import { ChatMessageBubble } from "../ChatMessageBubble";
import { ChatMessagePart } from "../ChatMessagePart";
import { compileSlotValues } from "../../utils/compiler/compileSlotValues";

export interface FailureMessageProps {
    readonly agents: ChatAgents;
    readonly text?: string;
    readonly delay?: number;
    readonly time?: string;
}

export const FailureMessage: FC<FailureMessageProps> = (props) => {
    const { agents, text, delay, time } = props;

    const [countdown, setCountdown] = useState<number>(delay);

    const agent_names = Object.values(agents).filter((agent) => agent.requestFailed);

    useEffect(() => {
        if (delay !== 0) {
            let countdownValue = delay;
            const myInterval = setInterval(function () {
                countdownValue--;
                setCountdown(countdownValue);
                if (countdownValue === 0) {
                    clearInterval(myInterval);
                }
            }, 1000);
        } else {
            setCountdown(5);
        }
    }, [delay]);

    const slots = useMemo(() => {
        return {
            sec: {
                name: "sec",
                value: countdown,
            },
        };
    }, [countdown]);

    const failureMessage = useMemo(() => {
        return compileSlotValues(text, slots);
    }, [text, slots]);

    if (countdown === 0) {
        return <></>;
    }

    return (
        <>
            {agent_names.map((agent) => {
                return (
                    <div
                        className="chat-msg-container-wrapper"
                        key={`failure-msg-${agent.user.nick}`}>
                        <div className="chat-msg-container agent" key={agent.user.nick}>
                            <ChatMessagePart user={agent.user} showAvatar={true}>
                                <div className="chat-msg">
                                    <ChatMessageBubble owner="others" hasTail={true}>
                                        <span className="message-sr-only">{"at " + time + " the bot said"}</span>
                                        <span>{failureMessage}</span>
                                    </ChatMessageBubble>
                                </div>
                            </ChatMessagePart>
                        </div>
                    </div>
                );
            })}
        </>
    );
};
